<template>
  <el-drawer
    :title="drawerTitle"
    :visible.sync="visible"
    :direction="direction"
    :before-close="handleClose"
    :size="width"
    :append-to-body="true"
    @open="open">
    <div class="drawer__content scrollable only-y" :style="divHeight" >
      <el-form>
        <el-row>
          <el-col>
            <el-form-item :label="$t('dashboards.dashboardList')">
              <el-select :value="dashboardToAdd" v-model="model.dashboardType" value-key="id" @change="selectDashboard">
                <el-option
                  v-for="item in dashboards"
                  :key="item.id"
                  :label="$t('dashboards.'+item.name)"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- dashboard title -->
        <el-form-item :label="$t('common.title')" v-if="dashboardToAdd.id!=null">
          <el-input v-model="dashboardName"></el-input>
        </el-form-item>
        <!-- END dashboard title -->
        <el-collapse>
          <!-- Filters -->
          <el-collapse-item :title="$t('common.filters')" name="1" v-if="dashboardToAdd.id!=null && dashboardToAdd.dialogSettings.filters==true">
              <div v-for="(c, index) in dashboardToAdd.configuration.filters" style="margin:10px;padding-bottom:20px;">
                <el-col>
                  <el-checkbox v-if="isBoolean(c)" :value="dashboardToAdd.configuration.filters[index]" @change="v=>changeFilters(v,index)">{{dashboardFilterLabel(index)}}</el-checkbox>
                </el-col>
              </div>
          </el-collapse-item>
          <!-- END Filters -->
          <!-- Customer classes filter -->
          <el-collapse-item :title="$t('clients.class')" name="2" v-if="dashboardToAdd.id!=null && dashboardToAdd.dialogSettings.customerClasses!=null">
            <el-form-item label=" ">
              <el-select
                :value="dashboardToAdd.configuration.customerClasses"
                multiple
                collapse-tags
                @change="changeCustomerClasses">
                <el-option
                  v-for="u in customerClasses"
                  :key="u.id"
                  :label="u.code"
                  :value="u.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <!-- END Customer classes filter -->
          <!-- Inventory filter -->
          <el-collapse-item :title="$t('common.inventories')" name="2.1" v-if="dashboardToAdd.id!=null && dashboardToAdd.dialogSettings.inventories!=null">
            <el-form-item label=" ">
              <SelectInventory
                @selected="changeSelectedInventories"
                :multiple="dashboardToAdd.dialogSettings.inventories.multiple"
                :selectedInventories="dashboardToAdd.configuration.inventories"
              />
            </el-form-item>
          </el-collapse-item>
          <!-- END Inventory filter -->
          <!-- Product filters -->
          <el-collapse-item :title="$t('common.products')" name="3" v-if="dashboardToAdd.id!=null && dashboardToAdd.dialogSettings.productId!=null">
            <el-form-item label=" ">
                <SelectProduct :selectedProduct="dashboardToAdd.configuration.productId" @selected="setProductFilter"></SelectProduct>
            </el-form-item>
          </el-collapse-item>
          <!-- END Product filters -->
          <!-- sales rep filters -->
          <el-collapse-item :title="$t('clients.rep')" name="4" v-if="dashboardToAdd.id!=null && dashboardToAdd.dialogSettings.sales_rep!=null">
            <el-form-item label=" ">
              <el-select
                :value="dashboardToAdd.configuration.sales_reps"
                multiple
                collapse-tags
                @change="changeSalesRep">
                <el-option
                  v-for="u in filterUserWithRoleRep"
                  :key="u.id"
                  :label="u.firstName + ' ' + u.lastName"
                  :value="u.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <!-- END sales rep filters -->
          <el-collapse-item :title="$t('common.criterias')" name="5" v-if="dashboardToAdd.id!=null && dashboardToAdd.dialogSettings.criterias!=null">
              <el-select
                collapse-tags
                v-model="localCriteria"
                @change="selectCriteria">
                <el-option
                  v-for="c in dashboardToAdd.dialogSettings.criterias"
                  :key="c.id"
                  :label="$t('dashboard-dialog.'+dashboardToAdd.code+'.criterias.'+c.code)"
                  :value="c">
                </el-option>
              </el-select>
              <el-table
                :data="dashboardToAdd.configuration.criterias"
                style="width: 100%"
                :empty-text="$t('common.noCriteriasSelected')">
                <el-table-column
                  prop="field"
                  :label="$t('common.field')">
                  <template slot-scope="scope">
                    <span>{{$t('dashboard-dialog.'+dashboardToAdd.code+'.criterias.'+scope.row.code)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                :label="$t('common.operator')">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.selectedOperator" placeholder="Select" @change="v => setOperatorOnCriteria({id:scope.row.id, operator:v})">
                      <el-option
                        v-for="operator in scope.row.operators"
                        :key="operator"
                        :label="operator"
                        :value="operator">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common.value')">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.selectedValue" placeholder="Select" @change="v => setValueOnCriteria({id:scope.row.id, value:v})">
                      <el-option
                        v-for="value in scope.row.values"
                        :key="value"
                        :label="$t('dashboard-dialog.criterias_values.'+value)"
                        :value="value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column width="60">
                  <template slot-scope="scope">
                      <el-button icon="el-icon-close" size="small" circle @click="removeCriteria(scope.row.id)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
          </el-collapse-item>
          <!-- field selection -->
          <el-collapse-item :title="$t('common.field')" name="6" v-if="dashboardToAdd.id!=null && dashboardToAdd.dialogSettings.fields!=null">

            <el-checkbox-group v-model="dashboardFields">
              <el-row v-for="(f, index) in dashboardToAdd.dialogSettings.fields" :key="index">
                <el-col>
                    <el-checkbox  :label="f">{{$t('dashboard-dialog.'+dashboardToAdd.code+'.fields.'+f)}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>



        <div class="dialog-footer card-shadow--large">
          <el-button @click="handleClose">{{$t('common.Cancel')}}</el-button>
          <el-button type="primary" @click="save" :disabled="dashboardToAdd.id==null">{{saveButtonLabel}}</el-button>
        </div>
      </el-form>
    </div>
  </el-drawer>
</template>
<script>
import moment from 'moment-timezone'
import SelectProduct from '@/components/product/select-product'
import { mapActions, mapState, mapGetters } from 'vuex';
import SelectInventory from '@/components/inventory/select-inventory';
export default {
  name: 'dashboard-dialog',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      localCriteria : null,
      model : {
        dashboardType: null,
      }
    };
  },components: {
    SelectProduct,
    SelectInventory
  },
  watch : {

  },
	methods: {
    open(){
    this.syncDashboardTypeSelection();
    },
    syncDashboardTypeSelection(){
      if (this.dashboardToAdd == null) {
        return;
      }

      const dashboardSelected = _.find(this.dashboards, d => d.name === this.dashboardToAdd.name);
      if (dashboardSelected != null) {
        this.model.dashboardType = dashboardSelected;
      }
    },
    selectCriteria(c){
      this.addCriteria(c);
      this.localCriteria=null;
    },
    resetFields(){
      this.model.dashboardType = null;
    },
    handleClose(){
      this.$emit('close');
      this.reset();
      this.resetFields();
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    selectDashboard(dashboard){
      this.setDashboard(dashboard);
      if(this.dashboardName==null || this.dashboardName==''){
        this.dashboardName = this.$i18n.t('dashboards.'+dashboard.name);
      }
    },
    isBoolean(c){
      return _.isBoolean(c);
    },
    dashboardFilterLabel(filterCode) {
      const translationKey = `dashboard-dialog.filters.${filterCode}`;
      return this.$te(translationKey) ? this.$t(translationKey) : filterCode;
    },
    changeFilters(value, propName){
      this.setFiltersItem({propName, value});
    },
    changeSalesRep(salesReps){
      this.setSalesReps(salesReps);
    },
    setProductFilter(product){
      this.setProductId(product.id)
    },
    changeCustomerClasses(customerClasses){
      this.setCustomerClasses(customerClasses);
    },
    changeSelectedInventories(inventories){
      this.setInventories(inventories);
    },
    save(){
      const saveAction = this.isEditMode ? this.update : this.post;
      saveAction()
        .then((dashboard)=>{
          const payload = this.isEditMode ? _.cloneDeep(this.dashboardToAdd) : dashboard;
          this.$emit(this.isEditMode ? 'updated' : 'created', payload);
          this.handleClose();
          this.$message({
            message: this.isEditMode ? 'Le dashboard a été modifié avec succès' : 'Le dashboard a été ajouté avec succès',
            type: 'success'
          });
        })
    },
    ...mapActions('dashboardDialog', ['setDashboard','setFiltersItem','setSalesReps','setCustomerClasses', 'setInventories','setProductId','setDashboardTitle','post','update','reset','addCriteria','setOperatorOnCriteria','removeCriteria','setValueOnCriteria','setDashboardFields']),
    ...mapActions('statuses', ['fetchSalesOrderStatuses','fetchPurchaseOrderStatuses','fetchInvoiceStatuses','fetchPackageStatuses']),
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('controlData',['fetchCustomerClasses'])
  },
	computed: {
    dashboardName : {
      get(){return this.dashboardToAdd.configuration.title},
      set(title){this.setDashboardTitle(title);}
    },
    dashboardFields : {
      get(){return this.dashboardToAdd.configuration.fields},
      set(fields){this.setDashboardFields(fields)}
    },
    divHeight(){
      return "height :"+(this.window.height-145) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    isEditMode() {
      return this.editingDashboardId != null;
    },
    drawerTitle() {
      return this.isEditMode ? this.$t('common.Edit') : this.$t('dashboards.addDashboard');
    },
    saveButtonLabel() {
      return this.isEditMode ? this.$t('common.save') : this.$t('common.Add');
    },
    ...mapState('dashboardDialog',['dashboards','dashboardToAdd','editingDashboardId']),
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
    ...mapState('controlData',['customerClasses'])
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.fetchSalesOrderStatuses();
    this.fetchPurchaseOrderStatuses();
    this.fetchInvoiceStatuses();
    this.fetchPackageStatuses();
    this.fetchAdminUsers();
    this.fetchCustomerClasses();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-60px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:1000;
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
